import UiModal from '../../../../js/components/UiModal/UiModal'
import { AutoPaymentForm } from '../AutoPaymentForm/scripts'
import { showAlchemerePopup } from '../../../../js/components/Alchemere'
import { Media } from '../../../../js/utils/const'

class AutopaymentModal extends UiModal {
  constructor(template, { nomenclatureId, blockName, methods, type = 'pay', callback }) {
    super(template, {
      blockTriggerName: blockName,
      isCenter: true,
      wrapperClass: 'autopayment-modal'
    })

    if (!methods) {
      const error = new Error('[Autopayment modal]: data is required')

      window.Sentry?.captureException(error)
      throw error
    }

    this.callback = callback
    this.methods = methods
    this.type = type
    this.nomenclatureId = nomenclatureId

    this.formInstance = null
    this.formElement = template

    this.smMax = window.matchMedia(`(max-width: ${Media.SM_MAX}px)`)
  }

  beforeMounted() {
    this.renderForm()

    if (this.smMax.matches) {
      this.scrollingEl.addEventListener('scroll', this.modalScrollHandler)
      window.addEventListener('resize', this.calcFooterHeight)
    }

    this.smMax.addEventListener('change', this.smMediaChangeHandler)
    this.formInstance.form.addEventListener('form-success', this.formSuccessHandler)
  }

  mounted() {
    super.mounted()

    if (this.smMax.matches) {
      this.setShadowForFooter(this.scrollingEl)
      this.calcFooterHeight()
    }

    this.formInstance.setDetailsHeight()
  }

  beforeUnmounted() {
    if (this.smMax.matches) {
      this.scrollingEl.removeEventListener('scroll', this.modalScrollHandler)
    }

    this.smMax.removeEventListener('change', this.smMediaChangeHandler)
    this.formInstance.form.removeEventListener('form-success', this.formSuccessHandler)
  }

  renderForm() {
    this.formInstance = new AutoPaymentForm({
      wrapper: this.contentWrapper,
      template: this.formElement,
      nomenclatureId: this.nomenclatureId,
      methods: this.methods,
      type: this.type,
      blockName: this.blockTriggerName
    })

    this.formInstance.render()
  }

  smMediaChangeHandler = (evt) => {
    if (!evt.matches) {
      this.scrollingEl.removeEventListener('scroll', this.modalScrollHandler)
      window.removeEventListener('resize', this.calcFooterHeight)
      return
    }

    this.scrollingEl.addEventListener('scroll', this.modalScrollHandler)
    window.addEventListener('resize', this.calcFooterHeight)
    this.setShadowForFooter(this.scrollingEl)
    this.calcFooterHeight()
  }

  setShadowForFooter(target) {
    const isScroll = (target.scrollHeight - target.offsetHeight) !== target.scrollTop
    this.formInstance.template.classList.toggle('is-scroll', isScroll)
  }

  modalScrollHandler = (evt) => {
    this.setShadowForFooter(evt.target)
  }

  calcFooterHeight = () => {
    if (!this.smMax.matches) {
      this.formElement.style.paddingBottom = ''
      return
    }

    const footerHeight = this.formElement.querySelector('.auto-payment-form__footer')?.offsetHeight
    this.formElement.style.paddingBottom = `${footerHeight - 40}px`
  }

  formSuccessHandler = () => {
    this.close()
  }

  beforeClose() {
    if (this.callback && typeof this.callback === 'function') {
      this.callback('lead')
      return
    }

    showAlchemerePopup({
      type: 'lead',
      blockName: this.blockTriggerName
    })
  }
}

export const showAutopaymentModal = (template, { methods, nomenclatureId, type, blockName, callback }) => {
  if (!template) {
    return
  }

  if (!methods) {
    const data = JSON.parse(template.dataset.payments)
    methods = data?.[nomenclatureId]
  }

  methods && new AutopaymentModal(template, { nomenclatureId, methods, type, blockName, callback }).init()
}
